/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ url: NonNullable<unknown> }} Orders_Carrier_Additional_Payment_LinkInputs */

const en_orders_carrier_additional_payment_link = /** @type {(inputs: Orders_Carrier_Additional_Payment_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Additional payment needed. Link: ${i?.url}`)
};

const es_orders_carrier_additional_payment_link = /** @type {(inputs: Orders_Carrier_Additional_Payment_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se necesita pago adicional. Link: ${i?.url}`)
};

/**
* | output |
* | --- |
* | "Additional payment needed. Link: {url}" |
*
* @param {Orders_Carrier_Additional_Payment_LinkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_carrier_additional_payment_link = /** @type {((inputs: Orders_Carrier_Additional_Payment_LinkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Carrier_Additional_Payment_LinkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_carrier_additional_payment_link(inputs)
	return es_orders_carrier_additional_payment_link(inputs)
});